import { render, staticRenderFns } from "./edit-group-modal.vue?vue&type=template&id=67e4556f&"
import script from "./edit-group-modal.vue?vue&type=script&lang=js&"
export * from "./edit-group-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports